export const SupplierFieldLabels = {
  companyName: 'Company Name',
  contactName: 'Contact Name',
  email: 'Email Address',
  phoneNumber: 'Phone Number',
  address: 'Address',
  numberOfLocations: 'Number of Locations',
  primaryLocation: 'Primary Location',
  numberOfEmployees: 'Number of Employees',
  productServices: 'Product/Services Offered',
  hasQualityProgram: 'Has Quality Program?',
  qualityProgramBasedOn: 'System quality program is based on?',
  seperateFromProductionDepartment:
    'Quality program separate from Production Department?',
  seperateFromProductionDepartmentDescription: 'If no to the above, explain',
  hasCurrentQualityManual: 'Is there up to date quality manual?',
  hasOrganizationChart: 'Has organization chart?',
  hasTechnicalDataControl: 'Has technical data control?',
  hasDocumentRetentionControl: 'Has document retention control?',
  hasTrainingLogs: 'Has training logs?',
  hasShelfLifeProgram: 'Has shelf life program?',
  hasQualityControl: 'Has quality control?',
  hasReceivingInspectionProcedures: 'Has Receiving inspection procedures?',
  hasCalibrationProgram:
    'An outline of the tool and gauge calibration program?',
  hasRevisions: 'A revision page which reflects revisions?',
  qualityReviewProcedure:
    'How often Is the Quality Manual reviewed and by whom?',
  isQualityManualAvailable:
    'Is the Quality Manual readily available to employees?',
  attachments:
    'Upload any documents that you feel would support this evaluation',
  hasPassFailCriteria: 'Criteria for acceptance/rejection',
  hasMeasurementVerification:
    'Type of measurements/verification to be performed',
  hasMeasurementResults: 'A record of measurement results',
  hasQualityEvidenceProgram:
    'Do records provide evidence that the product meets the defined requirements?',
  hasNonconformanceProgram:
    'Is there a documented procedure in place for control and disposition of a non-conforming product?',
  hasInternalAuditProgram:
    'Is there an internal audit function, with audits and corrective actions maintained on file?',
  noInternalAuditProgramExplain:
    'If you answered NO or N/A to the question above, please explain:',
  internalAuditSchedule: 'How often are internal audits conducted?',
  hasCustomerComplaintProgram:
    'Is there a mechanism for handling customer complaints?',
  hasRootCauseAnalysisProgram:
    'Is analysis performed to identify root causes of problems/failures?',
  hasCorrectiveActionProgram:
    'Is there a Corrective/Preventive Action program in place?',
  hasCorrectiveActionProgramRetrospective:
    'Is there a process for actions to be taken when timely or effective corrective actions are not achieved?',
  nextReviewDate: 'Next Review Date',
  completed: 'Evaluation Completion Date',
  taskFiles: 'Document References'
} as const;

export type SupplierField = keyof typeof SupplierFieldLabels;

export const SupplierFields: SupplierField[] = Object.keys(
  SupplierFieldLabels
) as SupplierField[];
